
    // **BEGIN** Hextom TMS Integration - DO NOT MODIFY
      var hextom_tms = {
        selectorInsertType:  "float",
        regionType:  "region_name_currency_symbol",
        floatingPosition: "bottom_right",
        floatingPaddingHorizontal:  15,
        floatingPaddingVertical:  15,
        availableLocalesById: {},
        availableLocales: [],
        primaryLocaleById: {},
        merchantSelectedLocale: "shop_base",
        hasFlag: "yes",
        selectorFlagMap: {'ar': 'ar-JO', 'en': 'en'},
        displayType: "language_name",
        fontColor: "#000000",
        backgroundColor: "#FFFFFF",
        backgroundOpacity: "1.0",
        buttonFontColor: "#FFFFFF",
        buttonBackgroundColor: "#000000",
        selectorType: "market_language",
        selectorStyle: "dropdown",
        hasFlagRegion: "yes",    
        defaultRegion: "JO",    
        primaryRegionById: {},    
        availableRegionsByCode: {},    
        availableRegions: [],
        primaryDomain: "",
        popupEnable: false,
        popupTextColor: "#000000",
        popupBgColor: "#FFFFFF",
        popupBtnTextColor: "#FFFFFF",
        popupBtnBgColor: "#000000",
        regions: [{"name": "United States", "code": "US", "currency": {"code": "USD", "symbol": "$"}, "languages": {"English": {"name": "English", "native_name": "English", "code": "en", "default": true}, "\u0639\u0631\u0628\u064a": {"name": "\u0639\u0631\u0628\u064a(Arabic)", "native_name": "\u0639\u0631\u0628\u064a", "code": "ar", "default": false}}, "primary": true}],
      };
    // **END** Hextom TMS Integration - DO NOT MODIFY
    